(() => {
  'use strict';

  /* ==========================================================
     LE BON COLLAGÈNE — PRODUCT FINDER UI V1
     Questionnaire conditionnel + navigation + connexion moteur
     ========================================================== */


  /* ==========================================================
     OPTIONS COMMUNES
     ========================================================== */

  const GOAL_OPTIONS = [
    {
      label: "Améliorer l’apparence et la qualité de ma peau",
      value: 'skin'
    },
    {
      label: "Renforcer ou prendre soin de mes cheveux",
      value: 'hair'
    },
    {
      label: "Améliorer mon confort articulaire ou ma mobilité",
      value: 'joints'
    },
    {
      label: "Soutenir mon corps dans le cadre de ma pratique sportive",
      value: 'sport'
    },
    {
      label: "Préserver ma mobilité et mon corps en vieillissant",
      value: 'aging'
    }
  ];


  const SKIN_OPTIONS = [
    {
      label: "Prévenir l’apparition des premiers signes de l’âge",
      value: 'prevention'
    },
    {
      label: "Atténuer l’apparence de rides déjà présentes",
      value: 'wrinkles'
    },
    {
      label: "Améliorer la fermeté et l’élasticité",
      value: 'firmness'
    },
    {
      label: "Améliorer l’hydratation et le confort de ma peau",
      value: 'hydration'
    },
    {
      label: "Retrouver davantage d’éclat",
      value: 'radiance'
    },
    {
      label: "Agir globalement sur les signes de l’âge",
      value: 'global'
    }
  ];


  /* ==========================================================
     HELPERS CONDITIONS
     ========================================================== */

  function array(value) {
    return Array.isArray(value) ? value : [];
  }


  function has(state, key, value) {
    return array(state[key]).includes(value);
  }


  function mainGoal(state) {
    const goals = array(state.goals);

    if (goals.length === 1) {
      return goals[0];
    }

    return state.mainGoal || null;
  }


  function ageAllowsMenopause(state) {
    return [
      '35_44',
      '45_54',
      '55_64',
      '65_plus'
    ].includes(state.ageRange);
  }


  function menopauseStageRelevant(state) {
    return [
      'peri',
      'menopause',
      'post'
    ].includes(state.menopauseStage);
  }


  /* ==========================================================
     CONFIGURATION DES QUESTIONS
     ========================================================== */

  const TRANSITION_DURATION = 3000;

const TRANSITIONS = {
  goals: {
    title: "Passons maintenant à vos objectifs !",
    text: "Cela va nous permettre d’identifier les familles de produits les plus cohérentes avec vos attentes."
  },

  profile: {
    title: "Précisons maintenant vos besoins.",
    text: "Quelques questions supplémentaires vont nous aider à affiner la sélection."
  },

  preferences: {
    title: "Encore quelques préférences !",
    text: "Origine, composition et habitudes de consommation vont nous permettre de départager les formules."
  },

  final: {
    title: "Nous y sommes presque !",
    text: "Une toute dernière question avant de découvrir votre sélection."
  }
};
const ICON_BY_VALUE = {

  fish: 'wave',
  shellfish: 'drop',
  bovine: 'leaf',
  none: 'shield-check',

  beginner: 'book',
  intermediate: 'bulb',
  experienced: 'award',
  expert: 'flask',

  marine: 'wave',
  bovine: 'leaf',
  very_low: 'flask',
  simple: 'leaf',
  enriched: 'sparkle',

  skin: 'sparkle',
  hair: 'leaf',
  joints: 'shield-check',
  sport: 'chart-up',
  aging: 'clock',

  prevention: 'shield-check',
  wrinkles: 'wave',
  firmness: 'award',
  hydration: 'drop',
  radiance: 'sparkle',
  global: 'globe',

  shedding: 'refresh',
  fragility: 'shield-check',
  growth: 'chart-up',
  density: 'award',
  shine: 'sparkle',
  preserve: 'shield-check',

  stiffness: 'shield-clock',
  comfort: 'heart',
  mobility: 'refresh',
  muscle_fatigue: 'clock',
  sport_load: 'chart-up',

  strength: 'award',
  running: 'chart-up',
  crossfit: 'chart-up',
  team: 'heart',
  endurance: 'clock',
  impact: 'shield-check',

  tendons: 'shield-check',
  recovery: 'refresh',
  muscles: 'award',
  longevity: 'clock',

  low: 'leaf',
  occasional: 'clock',
  regular: 'refresh',
  intensive: 'chart-up',
  competition: 'award',

  balanced: 'sparkle',
  complete: 'package',

  neutral: 'drop',
  flavored: 'sparkle',
  easy_daily: 'clock',

  many: 'package',
  some: 'package',

  yes: 'shield-check',
  no: 'question',

  peri: 'wave',
  menopause: 'heart',
  post: 'clock',

  google: 'globe',
  health_professional: 'shield-check',
  word_of_mouth: 'heart',
  instagram: 'sparkle',
  tiktok: 'sparkle',
  ai: 'bulb',
  youtube: 'book',
  influencer: 'award',
  facebook: 'globe',
  other: 'question',

  no_preference: 'question',
  unknown: 'question',
  none: 'question'
};


function getIconMarkup(value) {

  const iconName =
    ICON_BY_VALUE[value] || 'question';

  const template =
    document.querySelector(
      `[data-product-finder-icons] template[data-icon="${iconName}"]`
    );

  if (!template) {
    return '';
  }

  return template.innerHTML.trim();
}
     const QUESTIONS = [

    /* ----------------------------------------------------------
       1. CONNAISSANCE
       ---------------------------------------------------------- */

    {
      id: 'knowledge',
      group: 'knowledge',
      type: 'single',
      title: "À quel point connaissez-vous déjà le collagène ?",
      options: [
        {
          label: "Je découvre complètement le collagène",
          value: 'beginner'
        },
        {
          label: "Je connais les grandes lignes, mais j’ai du mal à choisir",
          value: 'intermediate'
        },
        {
          label: "J’en ai déjà consommé",
          value: 'experienced'
        },
        {
          label: "Je connais bien le sujet et je sais déjà ce que je recherche",
          value: 'expert'
        }
      ]
    },


    {
      id: 'expertPreference',
      group: 'knowledge',
      type: 'single',
      title: "Avez-vous déjà une préférence ?",

      showIf(state) {
        return state.knowledge === 'expert';
      },

      options: [
        {
          label: "Collagène marin",
          value: 'marine'
        },
        {
          label: "Collagène bovin",
          value: 'bovine'
        },
        {
          label: "Peptides de très faible poids moléculaire",
          value: 'very_low'
        },
        {
          label: "Une formule contenant essentiellement du collagène",
          value: 'simple'
        },
        {
          label: "Une formule enrichie en actifs complémentaires",
          value: 'enriched'
        },
        {
          label: "Aucune préférence",
          value: 'none'
        }
      ]
    },


    /* ----------------------------------------------------------
       2. OBJECTIFS
       ---------------------------------------------------------- */

    {
      id: 'goals',
      group: 'goals',
      type: 'multiple',
      title: "Que souhaitez-vous améliorer avec votre cure de collagène ?",
      helper: "Vous pouvez sélectionner plusieurs réponses.",
      options: GOAL_OPTIONS
    },


    {
      id: 'mainGoal',
      group: 'goals',
      type: 'single',
      title: "Parmi ces objectifs, lequel est aujourd’hui votre priorité ?",

      showIf(state) {
        return array(state.goals).length > 1;
      },

      options(state) {
        return GOAL_OPTIONS.filter(option =>
          array(state.goals).includes(option.value)
        );
      }
    },


    /* ==========================================================
       BRANCHE PEAU
       ========================================================== */

    {
      id: 'skinGoals',
      group: 'profile',
      type: 'ranking',
      title: "Concernant votre peau, qu’aimeriez-vous améliorer ?",
      helper: "Veuillez classer par ordre de priorité ces éléments (1 étant la priorité absolue)",

      showIf(state) {
        return mainGoal(state) === 'skin';
      },

      options: SKIN_OPTIONS
    },


    {
      id: 'ageRange',
      group: 'profile',
      type: 'single',
      title: "Dans quelle tranche d’âge vous situez-vous ?",

      options: [
        { label: "Moins de 25 ans", value: 'under_25' },
        { label: "25–34 ans", value: '25_34' },
        { label: "35–44 ans", value: '35_44' },
        { label: "45–54 ans", value: '45_54' },
        { label: "55–64 ans", value: '55_64' },
        { label: "65 ans et plus", value: '65_plus' }
      ]
    },


    {
      id: 'biologicalSex',
      group: 'profile',
      type: 'single',
      title: "Quel est votre sexe biologique ? (sans parler d’identité de genre)",

      showIf(state) {
        return mainGoal(state) === 'skin';
      },

      options: [
        {
          label: "Femme",
          value: 'female'
        },
        {
          label: "Homme",
          value: 'male'
        }
      ]
    },


    {
      id: 'menopauseStage',
      group: 'profile',
      type: 'single',
      title: "Êtes-vous actuellement concernée par l’une de ces périodes ?",

      showIf(state) {
        return (
          mainGoal(state) === 'skin' &&
          state.biologicalSex === 'female' &&
          ageAllowsMenopause(state)
        );
      },

      options: [
        {
          label: "Périménopause / préménopause",
          value: 'peri'
        },
        {
          label: "Ménopause",
          value: 'menopause'
        },
        {
          label: "Post-ménopause",
          value: 'post'
        },
        {
          label: "Je ne suis concernée par aucune des périodes ci-dessus",
          value: 'no'
        },
        {
          label: "Je préfère ne pas répondre",
          value: 'prefer_not'
        }
      ]
    },


    {
      id: 'menopauseNeed',
      group: 'profile',
      type: 'single',
      title: "Souhaitez-vous que votre complément réponde aussi à des besoins spécifiques liés à cette période de vie ?",

      showIf(state) {
        return (
          mainGoal(state) === 'skin' &&
          menopauseStageRelevant(state)
        );
      },

      options: [
        {
          label: "Non, mon objectif reste essentiellement ma peau",
          value: 'none'
        },
        {
          label: "Oui, peau + confort lié à la ménopause",
          value: 'comfort'
        },
        {
          label: "Oui, peau + os / articulations / mobilité",
          value: 'mobility'
        },
        {
          label: "Oui, je recherche une approche la plus globale possible",
          value: 'global'
        }
      ]
    },


    /* ==========================================================
       BRANCHE CHEVEUX
       ========================================================== */

    {
      id: 'hairConcern',
      group: 'profile',
      type: 'single',
      title: "Quelle est votre principale préoccupation concernant vos cheveux ?",

      showIf(state) {
        return mainGoal(state) === 'hair';
      },

      options: [
        {
          label: "Ils tombent davantage que d’habitude",
          value: 'shedding'
        },
        {
          label: "Ils sont fragiles ou cassants",
          value: 'fragility'
        },
        {
          label: "Je souhaite soutenir leur croissance",
          value: 'growth'
        },
        {
          label: "Ils manquent de densité",
          value: 'density'
        },
        {
          label: "Ils manquent de brillance et de vitalité",
          value: 'shine'
        },
        {
          label: "Je souhaite simplement les préserver",
          value: 'preserve'
        }
      ]
    },


    {
      id: 'hairFormulaPreference',
      group: 'profile',
      type: 'single',
      title: "Recherchez-vous une formule spécifiquement enrichie en actifs destinés aux cheveux ?",

      showIf(state) {
        return mainGoal(state) === 'hair';
      },

      options: [
        {
          label: "Oui",
          value: 'specific'
        },
        {
          label: "Non, je préfère un collagène plus simple et polyvalent",
          value: 'simple'
        },
        {
          label: "Aucune préférence",
          value: 'none'
        }
      ]
    },


    /* ==========================================================
       BRANCHE ARTICULATIONS
       ========================================================== */

    {
      id: 'jointConcern',
      group: 'profile',
      type: 'single',
      title: "Qu’est-ce qui vous préoccupe principalement ?",

      showIf(state) {
        return mainGoal(state) === 'joints';
      },

      options: [
        {
          label: "Une sensation de raideur au quotidien",
          value: 'stiffness'
        },
        {
          label: "Le confort de mes articulations",
          value: 'comfort'
        },
        {
          label: "Une perte de souplesse ou de mobilité",
          value: 'mobility'
        },
        {
          label: "Je souhaite préserver mes articulations avec l’âge",
          value: 'aging'
        },
        {
          label: "Mes muscles fatiguent facilement",
          value: 'muscle_fatigue'
        },
        {
          label: "Mes articulations sont principalement sollicitées par le sport",
          value: 'sport_load'
        }
      ]
    },


    {
      id: 'jointActivityLevel',
      group: 'profile',
      type: 'single',
      title: "Quel est votre niveau d’activité physique ?",

      showIf(state) {
        return mainGoal(state) === 'joints';
      },

      options: [
        { label: "Faible", value: 'low' },
        { label: "Occasionnel", value: 'occasional' },
        { label: "Régulier", value: 'regular' },
        { label: "Intensif", value: 'intensive' },
        { label: "Compétition", value: 'competition' }
      ]
    },


    /* ==========================================================
       BRANCHE SPORT
       ========================================================== */

    {
      id: 'sportType',
      group: 'profile',
      type: 'single',
      title: "Quelle activité pratiquez-vous principalement ?",

      showIf(state) {
        return mainGoal(state) === 'sport';
      },

      options: [
        { label: "Musculation", value: 'strength' },
        { label: "Course à pied", value: 'running' },
        {
          label: "CrossFit / Hyrox / fitness intensif",
          value: 'crossfit'
        },
        {
          label: "Sport collectif",
          value: 'team'
        },
        {
          label: "Cyclisme / endurance",
          value: 'endurance'
        },
        {
          label: "Sport avec impacts répétés",
          value: 'impact'
        },
        {
          label: "Autre activité",
          value: 'other'
        }
      ]
    },


    {
      id: 'sportGoal',
      group: 'profile',
      type: 'single',
      title: "Qu’est-ce que vous cherchez principalement à soutenir ?",

      showIf(state) {
        return mainGoal(state) === 'sport';
      },

      options: [
        {
          label: "Mes tendons et ligaments",
          value: 'tendons'
        },
        {
          label: "Mes articulations",
          value: 'joints'
        },
        {
          label: "Ma récupération après l’effort",
          value: 'recovery'
        },
        {
          label: "Mes muscles et la fatigue",
          value: 'muscles'
        },
        {
          label: "Ma longévité sportive",
          value: 'longevity'
        }
      ]
    },


    {
      id: 'sportActivityLevel',
      group: 'profile',
      type: 'single',
      title: "À quelle fréquence vous entraînez-vous ?",

      showIf(state) {
        return mainGoal(state) === 'sport';
      },

      options: [
        {
          label: "1 à 2 fois par semaine",
          value: 'occasional'
        },
        {
          label: "3 à 4 fois par semaine",
          value: 'regular'
        },
        {
          label: "5 fois ou plus par semaine",
          value: 'intensive'
        },
        {
          label: "Je pratique en compétition",
          value: 'competition'
        }
      ]
    },


    {
      id: 'antidopingPreference',
      group: 'profile',
      type: 'single',
      title: "Êtes-vous soumis à des contrôles antidopage ou recherchez-vous spécifiquement un produit disposant d’une certification adaptée aux sportifs ?",

      showIf(state) {
        return mainGoal(state) === 'sport';
      },

      options: [
        {
          label: "Oui",
          value: 'yes'
        },
        {
          label: "Non / ce n’est pas un critère",
          value: 'no'
        }
      ]
    },


    {
      id: 'sportFormulaPreference',
      group: 'profile',
      type: 'single',
      title: "Que préférez-vous ?",

      showIf(state) {
        return mainGoal(state) === 'sport';
      },

      options: [
        {
          label: "Du collagène avec une composition très simple",
          value: 'simple'
        },
        {
          label: "Une formule sportive enrichie en actifs complémentaires",
          value: 'complete'
        },
        {
          label: "Aucune préférence",
          value: 'none'
        }
      ]
    },


    /* ==========================================================
       BRANCHE BIEN-VIEILLIR
       ========================================================== */

    {
      id: 'agingGoal',
      group: 'profile',
      type: 'single',
      title: "Qu’aimeriez-vous surtout préserver avec l’âge ?",

      showIf(state) {
        return mainGoal(state) === 'aging';
      },

      options: [
        {
          label: "L’apparence de ma peau",
          value: 'skin'
        },
        {
          label: "Ma mobilité et mes articulations",
          value: 'joints'
        },
        {
          label: "Mes muscles et ma capacité à rester actif",
          value: 'muscles'
        },
        {
          label: "Ma peau ET ma mobilité",
          value: 'skin_mobility'
        },
        {
          label: "Je suis concernée par la ménopause",
          value: 'menopause'
        },
        {
          label: "Je recherche simplement un collagène polyvalent",
          value: 'polyvalent'
        }
      ]
    },


    {
      id: 'agingMenopauseNeed',
      group: 'profile',
      type: 'single',
      title: "Quel type d’accompagnement recherchez-vous principalement ?",

      showIf(state) {
        return (
          mainGoal(state) === 'aging' &&
          state.agingGoal === 'menopause'
        );
      },

      options: [
        {
          label: "Mon objectif reste principalement la peau",
          value: 'none'
        },
        {
          label: "Peau + confort lié à la ménopause",
          value: 'comfort'
        },
        {
          label: "Peau + os / articulations / mobilité",
          value: 'mobility'
        },
        {
          label: "Une approche la plus globale possible",
          value: 'global'
        }
      ]
    },


    /* ==========================================================
       QUESTIONS COMMUNES
       ========================================================== */

    {
      id: 'avoidTags',
      group: 'preferences',
      type: 'multiple',
      title: "Avez-vous une des allergies ou intolérances indiquées ci-dessous ?",

      options: [
        {
          label: "Poisson",
          value: 'fish'
        },
        {
          label: "Crustacés / mollusques",
          value: 'shellfish'
        },
        {
          label: "Produits bovins",
          value: 'bovine'
        },
        {
          label: "Aucune de ces réponses",
          value: 'none'
        }
      ]
    },


    {
      id: 'originPreference',
      group: 'preferences',
      type: 'single',
      title: "Avez-vous une préférence concernant l’origine de votre collagène ?",

      options: [
        {
          label: "Marine",
          value: 'marine'
        },
        {
          label: "Bovine",
          value: 'bovine'
        },
        {
           label: "Aucune préférence",
          value: 'no_preference'
},
{
  label: "Je ne sais pas",
  value: 'unknown'
}
      ]
    },


    {
      id: 'formulaPreference',
      group: 'preferences',
      type: 'single',
      title: "Que recherchez-vous dans la composition ?",

      showIf(state) {
        const goal = mainGoal(state);

        /* Sport possède déjà une question de composition dédiée. */
        if (goal === 'sport') {
          return false;
        }

        /* Cheveux possède déjà sa question spécifique. */
        if (goal === 'hair') {
          return false;
        }

        return true;
      },

      options: [
        {
          label: "Le minimum d’ingrédients possible",
          value: 'simple'
        },
        {
          label: "Du collagène associé à quelques actifs utiles",
          value: 'balanced'
        },
        {
          label: "Une formule très complète",
          value: 'complete'
        },
        {
          label: "Je préfère que vous décidiez pour moi",
          value: 'none'
        }
      ]
    },


    {
      id: 'practicality',
      group: 'preferences',
      type: 'single',
      title: "Avez-vous une préférence particulière pour votre cure au quotidien ?",

      options: [
        {
          label: "Je préfère quelque chose de neutre ou sans goût marqué",
          value: 'neutral'
        },
        {
          label: "Un produit aromatisé me convient",
          value: 'flavored'
        },
        {
          label: "Je privilégie quelque chose de très simple à intégrer à mon quotidien",
          value: 'easy_daily'
        },
        {
          label: "Aucune préférence",
          value: 'none'
        }
      ]
    },


    {
      id: 'supplements',
      group: 'preferences',
      type: 'single',
      title: "Prenez-vous déjà régulièrement des compléments contenant des vitamines ou minéraux ?",

      options: [
        {
          label: "Oui, plusieurs",
          value: 'many'
        },
        {
          label: "Oui, un ou deux",
          value: 'some'
        },
        {
          label: "Non",
          value: 'none'
        },
        {
          label: "Je ne sais pas",
          value: 'unknown'
        }
      ]
    }
    ,
{
  id: 'discoverySource',
  group: 'final',
  type: 'multiple',

  title: "Dernière question ! Comment avez-vous entendu parler de nous ?",

  options: [
    {
      label: "Recherche Google",
      value: 'google'
    },
    {
      label: "Professionnel de santé",
      value: 'health_professional'
    },
    {
      label: "Bouche à oreille",
      value: 'word_of_mouth'
    },
    {
      label: "Instagram",
      value: 'instagram'
    },
    {
      label: "TikTok",
      value: 'tiktok'
    },
    {
      label: "Intelligence Artificielle",
      value: 'ai'
    },
    {
      label: "YouTube",
      value: 'youtube'
    },
    {
      label: "Influenceur",
      value: 'influencer'
    },
    {
      label: "Facebook",
      value: 'facebook'
    },
    {
      label: "Autre",
      value: 'other'
    }
  ]
}

  ];


  /* ==========================================================
     APPLICATION
     ========================================================== */

  function createApp(root) {

    const state = {
  email: ''
};
    const section = root.closest('[data-product-finder-section]');

const welcomeContent = {
  eyebrow: section?.dataset.welcomeEyebrow || 'Trouvez votre collagène',
  title: section?.dataset.welcomeTitle || 'Quel complément au collagène est fait pour vous ?',
  description: section?.dataset.welcomeDescription || '',
  button: section?.dataset.welcomeButton || 'Commencer le questionnaire'
};

let screen = 'welcome';

    let currentQuestionId = null;
    let showingResults = false;
    let autoAdvanceTimer = null;

function scrollToFinderTop() {

  requestAnimationFrame(() => {

    const header =
      document.querySelector('header');

    const fallbackHeaderHeight =
      window.innerWidth <= 749 ? 72 : 80;

    const headerHeight =
      header
        ? header.getBoundingClientRect().height
        : fallbackHeaderHeight;

    const rootTop =
      root.getBoundingClientRect().top +
      window.scrollY;

    const targetTop =
      rootTop - headerHeight - 16;

    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: 'auto'
    });

  });

}

    function visibleQuestions() {
      return QUESTIONS.filter(question => {
        if (typeof question.showIf !== 'function') {
          return true;
        }

        return question.showIf(state);
      });
    }


    function getOptions(question) {
      if (typeof question.options === 'function') {
        return question.options(state);
      }

      return question.options || [];
    }


    function getQuestion(id) {
      return QUESTIONS.find(question => question.id === id);
    }


    function questionHasAnswer(question) {
      const value = state[question.id];

      if (
  question.type === 'multiple' ||
  question.type === 'ranking'
) {
  return (
    Array.isArray(state[question.id]) &&
    state[question.id].length > 0
  );
}

      return value !== undefined &&
             value !== null &&
             value !== '';
    }


    function cleanDependentAnswers() {

      const goals = array(state.goals);

      if (
        state.mainGoal &&
        !goals.includes(state.mainGoal)
      ) {
        delete state.mainGoal;
      }


      if (
        state.skinPriority &&
        !array(state.skinGoals).includes(state.skinPriority)
      ) {
        delete state.skinPriority;
      }


      /*
        Si la personne n'est plus dans une branche,
        on ne laisse pas des réponses anciennes influencer
        le moteur.
      */

      const visibleIds = new Set(
        visibleQuestions().map(question => question.id)
      );

      QUESTIONS.forEach(question => {
        if (!visibleIds.has(question.id)) {
          delete state[question.id];
        }
      });
    }


    function setSingleAnswer(questionId, value) {
      state[questionId] = value;
      cleanDependentAnswers();
    }


    function toggleMultipleAnswer(questionId, value) {

      let values = array(state[questionId]);


      if (questionId === 'avoidTags') {

        if (value === 'none') {
          values = ['none'];
        }

        else {
          values = values.filter(item => item !== 'none');

          if (values.includes(value)) {
            values = values.filter(item => item !== value);
          }

          else {
            values.push(value);
          }
        }

      }

      else {

        if (values.includes(value)) {
          values = values.filter(item => item !== value);
        }

        else {
          values.push(value);
        }
      }


      state[questionId] = values;

      cleanDependentAnswers();
    }
    function toggleRankingAnswer(questionId, value) {
  const current = Array.isArray(state[questionId])
    ? [...state[questionId]]
    : [];

  const existingIndex = current.indexOf(value);

  if (existingIndex !== -1) {
    current.splice(existingIndex, 1);
  } else {
    current.push(value);
  }

  state[questionId] = current;
}


    /* ==========================================================
       CONSTRUCTION DES RÉPONSES DU MOTEUR
       ========================================================== */

    function buildEngineAnswers() {

      const goal = mainGoal(state);

      let secondaryGoals =
        array(state.goals)
          .filter(item => item !== goal);


      /*
        Si le profil cheveux indique également
        un intérêt important pour la peau,
        on l'ajoute comme objectif secondaire.
      */


      let primarySubGoal = null;
      let secondarySubGoals = [];


      if (goal === 'skin') {

  const skinGoals =
    array(state.skinGoals);

  primarySubGoal =
    skinGoals.length > 0
      ? skinGoals[0]
      : null;

  secondarySubGoals =
    skinGoals.filter(
      item => item !== primarySubGoal
    );
}

      else if (goal === 'hair') {
        primarySubGoal =
          state.hairConcern || null;
      }


      else if (goal === 'joints') {
        primarySubGoal =
          state.jointConcern || null;
      }


      else if (goal === 'sport') {
        primarySubGoal =
          state.sportGoal || null;
      }


      else if (goal === 'aging') {
        primarySubGoal =
          state.agingGoal || null;
      }


      let formulaPreference =
        state.formulaPreference || null;


      if (goal === 'sport') {

        formulaPreference =
          state.sportFormulaPreference === 'none'
            ? null
            : state.sportFormulaPreference || null;
      }


      if (
        goal === 'hair' &&
        state.hairFormulaPreference === 'simple'
      ) {
        formulaPreference = 'simple';
      }


      let activityLevel = null;

      if (goal === 'joints') {
        activityLevel =
          state.jointActivityLevel || null;
      }

      else if (goal === 'sport') {
        activityLevel =
          state.sportActivityLevel || null;
      }


      let menopauseNeed = 'none';

      if (goal === 'skin') {
        menopauseNeed =
          state.menopauseNeed || 'none';
      }

      else if (
        goal === 'aging' &&
        state.agingGoal === 'menopause'
      ) {
        menopauseNeed =
          state.agingMenopauseNeed || 'none';
      }


      return {

        knowledge:
          state.knowledge || null,

        expertPreference:
          state.expertPreference === 'none'
            ? null
            : state.expertPreference || null,

        mainGoal: goal,

        secondaryGoals,

        primarySubGoal,

        secondarySubGoals,

        menopauseNeed,

        formulaPreference:
          formulaPreference === 'none'
            ? null
            : formulaPreference,

        originPreference:
  (
    state.originPreference === 'no_preference' ||
    state.originPreference === 'unknown'
  )
    ? null
    : state.originPreference || null,

        avoidTags:
          array(state.avoidTags)
            .filter(item => item !== 'none'),

        activityLevel,

        sportType:
          state.sportType || null,

        antidopingPreference:
          state.antidopingPreference || 'no',

        practicality:
          state.practicality || 'none',

        supplements:
          state.supplements || 'none',

        hairFormulaPreference:
          state.hairFormulaPreference || null
      };
    }


    /* ==========================================================
   ÉCRAN D'ACCUEIL
   ========================================================== */

function renderWelcome() {
  screen = 'welcome';

  root.innerHTML = `
    <div class="product-finder-ui product-finder-welcome">

      <p class="product-finder-welcome__eyebrow">
        ${welcomeContent.eyebrow}
      </p>

      <h2 class="product-finder-welcome__title">
        ${welcomeContent.title}
      </h2>

      <p class="product-finder-welcome__description">
        ${welcomeContent.description}
      </p>

      <button
        type="button"
        class="product-finder-welcome__button"
        data-product-finder-start
      >
        ${welcomeContent.button}
      </button>
      <p class="product-finder-welcome__disclaimer">
  Ceci n’est pas un diagnostic médical et ne remplace pas l’avis d’un professionnel de santé.
</p>

    </div>
  `;

  root
    .querySelector('[data-product-finder-start]')
    .addEventListener('click', renderNameScreen);
}

function renderNameScreen() {
  screen = 'name';

  root.innerHTML = `
    <div class="product-finder-ui product-finder-name">

      <p class="product-finder-ui__progress">
        Faisons connaissance
      </p>

      <h2 class="product-finder-ui__question">
        Comment pouvons-nous vous appeler ?
      </h2>

      <div class="product-finder-name__field">
        <input
          type="text"
          data-product-finder-name-input
          value="${state.firstName || ''}"
          placeholder="Votre prénom"
          autocomplete="given-name"
        >
      </div>

      <p
        class="product-finder-ui__error"
        data-product-finder-name-error
        hidden
      >
        Indiquez votre prénom pour continuer.
      </p>

      <div class="product-finder-ui__navigation">

        <button
          type="button"
          data-product-finder-name-back
        >
          Précédent
        </button>

        <button
        type="button"
        class="product-finder-name__next"
        data-product-finder-name-next
        ${state.firstName && state.firstName.trim() ? '' : 'disabled'}
      >
        Continuer
      </button>

      </div>

    </div>
  `;

  const input =
    root.querySelector('[data-product-finder-name-input]');
    const nextButton =
  root.querySelector('[data-product-finder-name-next]');


function updateNameButton() {

  const hasName =
    input.value.trim().length > 0;

  nextButton.disabled = !hasName;

  nextButton.classList.toggle(
    'is-active',
    hasName
  );
}


input.addEventListener(
  'input',
  updateNameButton
);

updateNameButton();

  input.focus();

  root
    .querySelector('[data-product-finder-name-back]')
    .addEventListener('click', renderWelcome);

  root
    .querySelector('[data-product-finder-name-next]')
    .addEventListener('click', () => {

      const firstName = input.value.trim();

      if (!firstName) {
        root.querySelector(
          '[data-product-finder-name-error]'
        ).hidden = false;

        return;
      }

      state.firstName = firstName;

      renderConsentScreen();
    });
}
function renderConsentScreen() {
  screen = 'consent';

  root.innerHTML = `
    <div class="product-finder-ui product-finder-consent">

      <p class="product-finder-ui__progress">
        Avant de commencer
      </p>

      <h2 class="product-finder-ui__question">
        Bienvenue ${state.firstName || ''} !
      </h2>

      <p class="product-finder-ui__helper">
        Nous allons vous poser quelques questions afin de vous proposer le complément qui correspond le mieux à vos besoins.
      </p>

      <label class="product-finder-consent__box">

        <input
          type="checkbox"
          data-product-finder-consent
          ${state.consent ? 'checked' : ''}
        >

        <span>
          J’accepte que nous récoltions et traitions mes données afin de me proposer une sélection personnalisée de produits.
        </span>

      </label>

      <div class="product-finder-ui__navigation">

        <button
          type="button"
          data-product-finder-consent-back
        >
          Précédent
        </button>

        <button
          type="button"
          data-product-finder-consent-next
          ${state.consent ? '' : 'disabled'}
        >
          Commencer
        </button>

      </div>

    </div>
  `;

  const checkbox =
    root.querySelector('[data-product-finder-consent]');

  const nextButton =
    root.querySelector('[data-product-finder-consent-next]');


  checkbox.addEventListener('change', () => {

    state.consent = checkbox.checked;

    nextButton.disabled = !checkbox.checked;
  });


  root
    .querySelector('[data-product-finder-consent-back]')
    .addEventListener('click', renderNameScreen);


  nextButton.addEventListener('click', () => {

    if (!state.consent) {
      return;
    }

    const firstQuestion =
      visibleQuestions()[0];

    renderQuestion(firstQuestion);
  });
}

/* ==========================================================
   AFFICHAGE QUESTION
   ========================================================== */
function renderTransition(group, callback) {

  const transition = TRANSITIONS[group];

  if (!transition) {
    callback();
    return;
  }

  screen = 'transition';

  root.innerHTML = `
    <div class="product-finder-ui product-finder-transition">

      <div class="product-finder-transition__content">

        <p class="product-finder-transition__eyebrow">
          Le Bon Collagène
        </p>

        <h2 class="product-finder-transition__title">
          ${transition.title}
        </h2>

        <p class="product-finder-transition__text">
          ${transition.text}
        </p>

        <div class="product-finder-transition__dots" aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <div class="product-finder-transition__progress">
          <span
            style="animation-duration: ${TRANSITION_DURATION}ms"
          ></span>
        </div>

      </div>

    </div>
  `;

  window.setTimeout(() => {
    callback();
  }, TRANSITION_DURATION);
}
function renderQuestion(question) {

  const isNewQuestion =
    currentQuestionId !== question.id;

  showingResults = false;

  currentQuestionId = question.id;

  const questions =
    visibleQuestions();

      const index =
        questions.findIndex(item =>
          item.id === question.id
        );
      
      const progress =
  ((index + 1) / questions.length) * 100;

      const options =
        getOptions(question);


      root.innerHTML = `
        <div class="product-finder-ui">

          <div class="product-finder-progress">

  <div class="product-finder-progress__meta">

    <span>
      Étape ${index + 1} sur ${questions.length}
    </span>

    <span>
      ${Math.round(progress)} %
    </span>

  </div>

  <div class="product-finder-progress__track">
    <div
      class="product-finder-progress__bar"
      style="width: ${progress}%"
    ></div>
  </div>

</div>

          <h2 class="product-finder-ui__question">
            ${question.title}
          </h2>

          ${
            question.helper
              ? `
                <p class="product-finder-ui__helper">
                  ${question.helper}
                </p>
              `
              : ''
          }

          <div class="product-finder-ui__options">

            ${options.map(option => {

  const selected =
  question.type === 'multiple' || question.type === 'ranking'
    ? array(state[question.id]).includes(option.value)
    : state[question.id] === option.value;

const rank =
  question.type === 'ranking'
    ? array(state[question.id]).indexOf(option.value) + 1
    : 0;

  const icon =
    getIconMarkup(option.value);

  return `
    <button
      type="button"
      class="product-finder-ui__option"
      data-option-value="${option.value}"
      aria-pressed="${selected}"
    >

      <span class="product-finder-ui__option-icon">
  ${getIconMarkup(option.value)}
</span>

${question.type === 'ranking' && rank > 0
  ? `<span class="product-finder-ui__rank">${rank}</span>`
  : ''
}

<span class="product-finder-ui__option-label">
  ${option.label}
</span>

    </button>
  `;

}).join('')}

          </div>

          <p
            class="product-finder-ui__error"
            data-product-finder-error
            hidden
          >
            Sélectionnez une réponse pour continuer.
          </p>

          <div class="product-finder-ui__navigation">

  ${
    index > 0
      ? `
        <button
          type="button"
          class="product-finder-ui__back"
          data-product-finder-previous
        >
          Précédent
        </button>
      `
      : '<span></span>'
  }

  ${
    question.type === 'multiple' || question.type === 'ranking'
      ? `
        <button
          type="button"
          class="product-finder-ui__next"
          data-product-finder-next
        >
          ${
            index === questions.length - 1
              ? 'Voir mes résultats'
              : 'Continuer'
          }
        </button>
      `
      : '<span></span>'
  }

</div>

        </div>
      `;


      root
        .querySelectorAll('[data-option-value]')
        .forEach(button => {

          button.addEventListener('click', () => {

            const value =
              button.dataset.optionValue;

            if (question.type === 'multiple') {

  toggleMultipleAnswer(
    question.id,
    value
  );

  renderQuestion(question);

  return;
}
if (question.type === 'ranking') {
  toggleRankingAnswer(
    question.id,
    value
  );

  renderQuestion(question);
  return;
}

/* Choix unique */

setSingleAnswer(
  question.id,
  value
);


/* On réaffiche brièvement la sélection */

renderQuestion(question);


/* Puis passage automatique */

window.clearTimeout(autoAdvanceTimer);

autoAdvanceTimer = window.setTimeout(() => {

  if (currentQuestionId === question.id) {
    goNext();
  }

}, 350);
          });
        });


      const previousButton =
        root.querySelector(
          '[data-product-finder-previous]'
        );

      if (previousButton) {

        previousButton.addEventListener(
          'click',
          goPrevious
        );
      }


      const nextButton =
  root.querySelector(
    '[data-product-finder-next]'
  );

if (nextButton) {
  nextButton.addEventListener(
    'click',
    goNext
  );
}


/*
  Si une nouvelle question vient d'être affichée,
  on replace le questionnaire sous le header.
*/
if (isNewQuestion) {
  scrollToFinderTop();
}

}


    /* ==========================================================
       NAVIGATION
       ========================================================== */

    function goPrevious() {

      const questions =
        visibleQuestions();

      const index =
        questions.findIndex(question =>
          question.id === currentQuestionId
        );

      if (index > 0) {
  renderQuestion(
    questions[index - 1]
  );
}
    }


    function goNext() {

      const current =
        getQuestion(currentQuestionId);


      if (!questionHasAnswer(current)) {

        const error =
          root.querySelector(
            '[data-product-finder-error]'
          );

        if (error) {
          error.hidden = false;
        }

        return;
      }


      cleanDependentAnswers();


      const questions =
        visibleQuestions();

      const index =
        questions.findIndex(question =>
          question.id === currentQuestionId
        );


      if (index < questions.length - 1) {

  const nextQuestion = questions[index + 1];

  const currentGroup = current.group || null;
  const nextGroup = nextQuestion.group || null;

  if (
  currentGroup &&
  nextGroup &&
  currentGroup !== nextGroup &&
  TRANSITIONS[nextGroup]
) {

  renderTransition(
  nextGroup,
  () => {

    renderQuestion(nextQuestion);

  }
);

} else {

  renderQuestion(nextQuestion);

}

return;
}

showResults();
    }


    /* ==========================================================
       RÉSULTATS TECHNIQUES V1
       ========================================================== */
      function getResultProductMarkup(productId) {

        const template =
          section.querySelector(
            `[data-product-result-id="${productId}"]`
          );

        if (!template) {
          return '';
        }

  return template.innerHTML.trim();
}

/* ==========================================================
   ENREGISTREMENT DES RÉPONSES PRODUCT FINDER
   ========================================================== */

const PRODUCT_FINDER_WEBHOOK_URL =
  'https://hook.eu1.make.com/5csjqwh8ewlnr7xdya445p3jsbdkuvpc';


function sendProductFinderSubmission(
  answers,
  result
) {

  if (state.consent !== true) {
    console.warn(
      '[Product Finder] Enregistrement ignoré : consentement absent.'
    );

    return;
  }


  if (
    !PRODUCT_FINDER_WEBHOOK_URL ||
    PRODUCT_FINDER_WEBHOOK_URL.includes(
      'COLLE_ICI'
    )
  ) {
    console.warn(
      '[Product Finder] Webhook Make non configuré.'
    );

    return;
  }


  const recommendations =
    result.recommendations || [];


  const primary =
    recommendations[0] || null;

  const secondary =
    recommendations[1] || null;


  const params =
  new URLSearchParams(
    window.location.search
  );


let storedAttribution = {};

try {
  storedAttribution =
    JSON.parse(
      localStorage.getItem(
        'lbc_attribution'
      ) || '{}'
    );
} catch (error) {
  storedAttribution = {};
}


function getAttributionValue(key) {
  return (
    params.get(key) ||
    storedAttribution[key] ||
    ''
  );
}


  const submissionId =
    window.crypto &&
    typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : `pf-${Date.now()}-${Math.random()
          .toString(36)
          .slice(2, 10)}`;


  const formData =
    new FormData();


  function appendField(
    key,
    value
  ) {

    if (
      value === null ||
      value === undefined
    ) {
      formData.append(
        key,
        ''
      );

      return;
    }


    if (Array.isArray(value)) {
      formData.append(
        key,
        value.join(' | ')
      );

      return;
    }


    if (typeof value === 'object') {
      formData.append(
        key,
        JSON.stringify(value)
      );

      return;
    }


    formData.append(
      key,
      String(value)
    );
  }


  /* ----------------------------------------------------------
     INFORMATIONS GÉNÉRALES
     ---------------------------------------------------------- */

  appendField(
    'submitted_at',
    new Date().toISOString()
  );

  appendField(
    'submission_id',
    submissionId
  );

  appendField(
    'first_name',
    state.firstName || ''
  );
  
  appendField(
    'email', 
    state.email || ''
  );

  appendField(
    'consent',
    state.consent === true
  );

  appendField(
    'consent_version',
    '2026-09-v1'
  );


  /* ----------------------------------------------------------
     CONNAISSANCE
     ---------------------------------------------------------- */

  appendField(
    'knowledge',
    state.knowledge || ''
  );

  appendField(
    'expert_preference',
    state.expertPreference || ''
  );


  /* ----------------------------------------------------------
     OBJECTIFS
     ---------------------------------------------------------- */

  appendField(
    'goals',
    state.goals || []
  );

  appendField(
    'main_goal',
    state.mainGoal || ''
  );


  /* ----------------------------------------------------------
     PEAU
     L'ordre du tableau correspond au classement choisi :
     index 0 = priorité n°1
     ---------------------------------------------------------- */

  appendField(
    'skin_goals_ranked',
    state.skinGoals || []
  );

  appendField(
    'age_range',
    state.ageRange || ''
  );

  appendField(
    'biological_sex',
    state.biologicalSex || ''
  );

  appendField(
    'menopause_stage',
    state.menopauseStage || ''
  );

  appendField(
    'menopause_need',
    state.menopauseNeed || ''
  );


  /* ----------------------------------------------------------
     CHEVEUX
     ---------------------------------------------------------- */

  appendField(
    'hair_concern',
    state.hairConcern || ''
  );

  appendField(
    'hair_skin_importance',
    state.hairSkinImportance || ''
  );

  appendField(
    'hair_formula_preference',
    state.hairFormulaPreference || ''
  );


  /* ----------------------------------------------------------
     ARTICULATIONS
     ---------------------------------------------------------- */

  appendField(
    'joint_concern',
    state.jointConcern || ''
  );

  appendField(
    'joint_activity_level',
    state.jointActivityLevel || ''
  );


  /* ----------------------------------------------------------
     SPORT
     ---------------------------------------------------------- */

  appendField(
    'sport_type',
    state.sportType || ''
  );

  appendField(
    'sport_goal',
    state.sportGoal || ''
  );

  appendField(
    'sport_activity_level',
    state.sportActivityLevel || ''
  );

  appendField(
    'antidoping_preference',
    state.antidopingPreference || ''
  );

  appendField(
    'sport_formula_preference',
    state.sportFormulaPreference || ''
  );


  /* ----------------------------------------------------------
     BIEN-VIEILLIR
     ---------------------------------------------------------- */

  appendField(
    'aging_goal',
    state.agingGoal || ''
  );

  appendField(
    'aging_menopause_need',
    state.agingMenopauseNeed || ''
  );


  /* ----------------------------------------------------------
     PRÉFÉRENCES COMMUNES
     ---------------------------------------------------------- */

  appendField(
    'avoid_tags',
    state.avoidTags || []
  );

  appendField(
    'origin_preference',
    state.originPreference || ''
  );

  appendField(
    'formula_preference',
    state.formulaPreference || ''
  );

  appendField(
    'practicality',
    state.practicality || ''
  );

  appendField(
    'supplements',
    state.supplements || ''
  );


  /* ----------------------------------------------------------
     ACQUISITION
     ---------------------------------------------------------- */

  appendField(
    'discovery_source',
    state.discoverySource || ''
  );


  /* ----------------------------------------------------------
     RECOMMANDATION PRINCIPALE
     ---------------------------------------------------------- */

  appendField(
    'recommendation_1_title',
    primary?.product?.title || ''
  );

  appendField(
    'recommendation_1_id',
    primary?.product?.id || ''
  );

  appendField(
    'recommendation_1_score',
    primary?.score ?? ''
  );


  /* ----------------------------------------------------------
     RECOMMANDATION SECONDAIRE
     ---------------------------------------------------------- */

  appendField(
    'recommendation_2_title',
    secondary?.product?.title || ''
  );

  appendField(
    'recommendation_2_id',
    secondary?.product?.id || ''
  );

  appendField(
    'recommendation_2_score',
    secondary?.score ?? ''
  );


  /* ----------------------------------------------------------
     MATCH PARTIEL
     ---------------------------------------------------------- */

  appendField(
    'partial_match',
    result.partialMatch === true
  );


  /* ----------------------------------------------------------
     NAVIGATION
     ---------------------------------------------------------- */

  appendField(
    'page_url',
    window.location.href
  );

  appendField(
    'referrer',
    document.referrer || ''
  );


  /* ----------------------------------------------------------
     UTM
     ---------------------------------------------------------- */

  appendField(
  'utm_source',
  getAttributionValue('utm_source')
);

appendField(
  'utm_medium',
  getAttributionValue('utm_medium')
);

appendField(
  'utm_campaign',
  getAttributionValue('utm_campaign')
);

appendField(
  'utm_content',
  getAttributionValue('utm_content')
);

appendField(
  'utm_term',
  getAttributionValue('utm_term')
);


  /* ----------------------------------------------------------
     SAUVEGARDE COMPLÈTE DES DONNÉES
     ---------------------------------------------------------- */

  appendField(
    'raw_answers_json',
    state
  );

  appendField(
    'normalized_answers_json',
    answers
  );

  appendField(
    'recommendations_json',
    recommendations.slice(0, 5)
  );


  /* ----------------------------------------------------------
     ENVOI
     ---------------------------------------------------------- */

  fetch(
    PRODUCT_FINDER_WEBHOOK_URL,
    {
      method: 'POST',
      body: formData,
      mode: 'no-cors',
      keepalive: true
    }
  )
    .then(() => {
      console.log(
        '[Product Finder] Données envoyées.'
      );
    })
    .catch((error) => {
      console.error(
        '[Product Finder] Erreur d’envoi :',
        error
      );
    });

}

function showEmailStep() {

  scrollToFinderTop();

  root.innerHTML = `
    <div class="product-finder-ui product-finder-email">

      <div class="product-finder-email__inner">

        <p class="product-finder-email__eyebrow">
          Votre sélection est prête
        </p>

        <h2 class="product-finder-email__title">
          Dernière étape avant vos recommandations
        </h2>

        <p class="product-finder-email__description">
          Indiquez votre adresse e-mail pour accéder à votre sélection personnalisée.
        </p>

        <form
          class="product-finder-email__form"
          data-product-finder-email-form
          novalidate
        >

          <div class="product-finder-email__field">

            <label
              for="ProductFinderEmail"
              class="product-finder-email__label"
            >
              Votre adresse e-mail
            </label>

            <input
              id="ProductFinderEmail"
              class="product-finder-email__input"
              type="email"
              name="email"
              autocomplete="email"
              inputmode="email"
              placeholder="vous@exemple.fr"
              value="${state.email || ''}"
              required
              data-product-finder-email
            >

            <p
              class="product-finder-email__error"
              data-product-finder-email-error
              hidden
            >
              Veuillez saisir une adresse e-mail valide.
            </p>

          </div>


          <button
            type="submit"
            class="product-finder-email__button"
          >
            Voir mes recommandations
            <span aria-hidden="true">→</span>
          </button>

        </form>


        <p class="product-finder-email__privacy">
          Votre adresse e-mail est utilisée dans le cadre de votre demande
          de recommandation personnalisée. Elle n’est pas utilisée pour
          vous envoyer des communications commerciales sans votre accord.
        </p>

      </div>

    </div>
  `;


  const form =
    root.querySelector(
      '[data-product-finder-email-form]'
    );

  const input =
    root.querySelector(
      '[data-product-finder-email]'
    );

  const error =
    root.querySelector(
      '[data-product-finder-email-error]'
    );


  if (!form || !input) {
    return;
  }


  input.focus();


  form.addEventListener(
    'submit',
    (event) => {

      event.preventDefault();

      const email =
        input.value.trim();


      const validEmail =
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
          email
        );


      if (!validEmail) {

        error.hidden = false;

        input.setAttribute(
          'aria-invalid',
          'true'
        );

        input.focus();

        return;
      }


      error.hidden = true;

      input.removeAttribute(
        'aria-invalid'
      );


      state.email = email;


      showResults();

    }
  );

}

    function showResults() {

  showingResults = true;

  const answers =
    buildEngineAnswers();


  if (!window.ProductFinderEngine) {

    root.innerHTML = `
      <p>
        Le moteur de recommandation n’est pas disponible.
      </p>
    `;

    return;
  }


  const result =
    window.ProductFinderEngine.rankProducts(
      window.LBCProductFinderProducts || [],
      answers
    );


  window.LBCLastProductFinderAnswers =
  answers;

window.LBCLastProductFinderResult =
  result;


/*
  Avant d'afficher les recommandations,
  on demande l'adresse e-mail.
*/
if (!state.email) {

  showEmailStep();

  return;

}


/*
  Une fois l'e-mail renseigné,
  on enregistre les réponses puis
  on affiche les recommandations.
*/
sendProductFinderSubmission(
  answers,
  result
);


const recommendations =
  result.recommendations || [];


  const primary =
    recommendations[0] || null;

  const secondary =
    recommendations[1] || null;


  if (!primary) {

    root.innerHTML = `
      <div class="product-finder-ui product-finder-result">

        <h2 class="product-finder-result__title">
          Notre recommandation
        </h2>

        <p>
          Nous n’avons pas pu générer de recommandation avec les informations disponibles.
        </p>

        <button
          type="button"
          class="product-finder-result__restart"
          data-product-finder-restart
        >
          Recommencer le questionnaire
        </button>

      </div>
    `;

    root
      .querySelector(
        '[data-product-finder-restart]'
      )
      .addEventListener(
        'click',
        restart
      );

    return;
  }


  const primaryProductMarkup =
    getResultProductMarkup(
      primary.product.id
    );


  const secondaryProductMarkup =
    secondary
      ? getResultProductMarkup(
          secondary.product.id
        )
      : '';


  const partialExplanation =
    result.partialMatch
      ? `
        <p class="product-finder-result__partial">
          Cette sélection est celle qui se rapproche le plus de vos réponses, même si aucun produit ne correspond totalement à votre objectif principal.
        </p>
      `
      : '';


  const secondaryMarkup =
    secondary
      ? `
        <section
          class="
            product-finder-result__choice
            product-finder-result__choice--secondary
          "
        >

          <div class="product-finder-result__choice-header">

            <span class="product-finder-result__choice-number">
              02
            </span>

            <div>

              <p class="product-finder-result__choice-label">
                Alternative recommandée
              </p>

              <h3 class="product-finder-result__choice-title">
                Une autre option pertinente
              </h3>

            </div>

          </div>

          <p class="product-finder-result__choice-description">
            Cette référence correspond également bien à votre profil et peut constituer une alternative selon vos préférences.
          </p>

          <div class="product-finder-result__product">

            ${secondaryProductMarkup}

          </div>

        </section>
      `
      : '';


  root.innerHTML = `
    <div class="product-finder-ui product-finder-result">

      <div class="product-finder-result__intro">

        <p class="product-finder-result__eyebrow">
          Votre sélection personnalisée
        </p>

        <h2 class="product-finder-result__title">
          Les collagènes les plus adaptés à votre profil
        </h2>

        <p class="product-finder-result__description">
          Nous avons comparé vos réponses aux caractéristiques des produits sélectionnés par notre comité scientifique.
        </p>

        ${partialExplanation}

      </div>


      <div class="product-finder-result__recommendations">

        <section
          class="
            product-finder-result__choice
            product-finder-result__choice--primary
          "
        >

          <div class="product-finder-result__choice-header">

            <span class="product-finder-result__choice-number">
              01
            </span>

            <div>

              <p class="product-finder-result__choice-label">
                Notre choix principal
              </p>

              <h3 class="product-finder-result__choice-title">
                La meilleure correspondance avec vos réponses
              </h3>

            </div>

          </div>

          <p class="product-finder-result__choice-description">
            C’est la référence qui obtient la meilleure correspondance globale avec les priorités et préférences que vous avez indiquées.
          </p>

          <div class="product-finder-result__product">

            ${primaryProductMarkup}

          </div>

        </section>


        ${secondaryMarkup}

      </div>


      <button
        type="button"
        class="product-finder-result__restart"
        data-product-finder-restart
      >
        Recommencer le questionnaire
      </button>

    </div>
  `;


  console.log(
    '[Product Finder] Réponses :',
    answers
  );

  console.log(
    '[Product Finder] Résultat :',
    result
  );


  root
    .querySelector(
      '[data-product-finder-restart]'
    )
    .addEventListener(
      'click',
      restart
    );
}


    function restart() {
      state.email = '';

  Object.keys(state).forEach(key => {
    delete state[key];
  });

  renderWelcome();
}


    /* ==========================================================
       INITIALISATION
       ========================================================== */

    renderWelcome();


    /* Exposition debug */
    window.ProductFinderUI = {
      QUESTIONS,
      state,
      buildEngineAnswers,
      restart
    };
  }


  /* ==========================================================
     LANCEMENT
     ========================================================== */

  function init() {

    document
      .querySelectorAll(
        '[data-product-finder-app]'
      )
      .forEach(root => {

        if (
          root.dataset.productFinderInitialized === 'true'
        ) {
          return;
        }

        root.dataset.productFinderInitialized =
          'true';

        createApp(root);
      });
  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  }

  else {
    init();
  }

})();